import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'store',
    loadChildren: () => import('./store/store.module').then( m => m.StorePageModule)
  },
  {
    path: 'productdetail',
    loadChildren: () => import('./productdetail/productdetail.module').then( m => m.ProductdetailPageModule)
  },
  {
    path: 'cart',
    loadChildren: () => import('./cart/cart.module').then( m => m.CartPageModule)
  },
  {
    path: 'checkout',
    loadChildren: () => import('./checkout/checkout.module').then( m => m.CheckoutPageModule)
  },
  {
    path: 'checkoutbranch',
    loadChildren: () => import('./checkoutbranch/checkoutbranch.module').then( m => m.CheckoutbranchPageModule)
  },  {
    path: 'checkoutaddress',
    loadChildren: () => import('./checkoutaddress/checkoutaddress.module').then( m => m.CheckoutaddressPageModule)
  },
  {
    path: 'orderdetail',
    loadChildren: () => import('./orderdetail/orderdetail.module').then( m => m.OrderdetailPageModule)
  },
  {
    path: 'vendordetail',
    loadChildren: () => import('./vendordetail/vendordetail.module').then( m => m.VendordetailPageModule)
  },



];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
